import adminRequest from "@/api/adminRequest";

export function getAlarmTimers(variant = '') {
    return adminRequest({
        url: `/alarmtimer/${variant}`,
        method: 'get'
    })
}

export function deleteAlarmTimer(id) {
    return adminRequest({
        url: `/alarmtimer/${id}`,
        method: 'delete'
    })
}

export function createAlarmTimer(data, variant = 'daily') {
    return adminRequest({
        url: `/alarmtimer/${variant}`,
        method: 'post',
        data,
    })
}
